import React, { Component } from "react";
import Swiper from "./Swiper";
import "swiper/dist/css/swiper.css";
import UpdateDimension from "../Utils/UpdateDimension";

class SwiperContainer extends Component {
  constructor(props) {
    super(props);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  updateDimensions() {
    this.swiper.updateSwiper();
    if (this.props.shouldSlideTo) {
      this.swiper.swiper.slideTo(0);
    }
  }
  render() {
    const { children, ...rest } = this.props;
    return (
      <>
        <UpdateDimension onUpdate={this.updateDimensions}>
          <Swiper
            {...rest}
            ref={swiper => {
              this.swiper = swiper;
            }}
          >
            {children}
          </Swiper>
        </UpdateDimension>
      </>
    );
  }
}
SwiperContainer.defaultProps = {
  shouldSlideTo: true
};

export default SwiperContainer;
